import React from "react";
import "./EraPage.css";

function Future() {
  return (
    <div className="era-page">
      {/* Banner */}
      <div className="era-banner colonialism-banner">
        <h1>🛡️ Colonialism & Resistance</h1>
        <p className="era-subtitle">Grade 10 – Voices Against Empire</p>
      </div>

      {/* Overview */}
      <section className="colonialism-overview">
        <h2>🌍 What is Colonialism?</h2>
        <p>
          Colonialism is when one country controls another to take its resources and power.
          From Africa to Asia to the Americas, powerful nations built empires that changed the world.
          But brave leaders and communities stood up and fought back for freedom and justice.
        </p>
      </section>

      {/* Key Figures & Events */}
      <section className="colonialism-key">
        <h2>✊ Resistance Around the World</h2>
        <ul>
          <li>🇮🇳 <strong>Mahatma Gandhi:</strong> Led peaceful protests to free India from British rule.</li>
          <li>🇨🇩 <strong>Patrice Lumumba:</strong> A leader in the Congo’s fight for independence.</li>
          <li>🇿🇦 <strong>Nelson Mandela:</strong> Fought against apartheid in South Africa.</li>
          <li>🇨🇦 <strong>Indigenous Peoples:</strong> Defended their lands and rights during colonization.</li>
        </ul>
      </section>

      {/* Story Time */}
      <section className="colonialism-story">
        <h2>📖 A Letter Never Sent</h2>
        <p>
          In 1947, a teenage girl in India writes a secret letter to her brother, jailed for joining a protest.
          She hides it under a rock where they used to meet. That rock becomes a symbol of her hope for change.
        </p>
      </section>

      {/* Video */}
      <section className="colonialism-media">
        <h2>🎥 Watch & Learn</h2>
        <img
    className="colonialism-illustration"
    src="/images/colonialism-era-scene.png" // Make sure this path matches your file!
    alt="Diverse youth representing global resistance and hope for freedom, standing together under the sun with peace and justice symbols"
    style={{
      width: "100%",
      maxWidth: 500,
      borderRadius: "1.5rem",
      margin: "0 auto",
      boxShadow: "0 4px 24px rgba(0,0,0,0.12)"
    }}
  />
      </section>

      {/* Quiz */}
      <section className="colonialism-quiz">
        <h2>🧠 Quick Challenge</h2>
        <ol>
          <li>What is colonialism?</li>
          <li>Who led peaceful protests in India?</li>
          <li>Why did colonized people resist?</li>
        </ol>
        <p><em>(Discuss with friends or family!)</em></p>
      </section>

      {/* Timeline */}
      <section className="colonialism-timeline">
        <h2>📅 Major Events</h2>
        <ul>
          <li>1492 – Columbus arrives in the Americas</li>
          <li>1857 – First War of Independence in India</li>
          <li>1947 – India gains independence from Britain</li>
          <li>1960s – Wave of African nations gain freedom</li>
        </ul>
      </section>
    </div>
  );
}

export default Future;
